import React from 'react';
import { FDContentContainer } from '@facet-wealth/design';
import { Route } from 'react-router-dom';
import Router, { Switch } from 'Components/UI/FacetRouter/FacetRouter';
import {
  advisorAccountSupportPath,
  advisorFacetPlanPath,
  advisorHouseholdBlueprint,
  advisorHouseholdLandingPagePath,
  advisorHouseholdPath,
  advisorHouseholdQuestionnaire,
  advisorHouseholdSnapshot,
  advisorHouseholdTimelinePath,
  advisorPlanPath,
  advisorSchedulerPath,
  advisorSecureFilesPath,
} from 'Consts/Strings';
import SecureFiles from 'Components/ClientApp/CombinedApp/Viewport/SecureFiles';
import { FileRow } from 'Components/ClientApp/CombinedApp/Viewport/SecureFiles/FileRow';
import Blueprint from 'Components/Blueprint';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { QueryVal } from 'Helpers/Query';
import moment from 'moment';
import { ACTIVE, PROSPECT } from 'Classes/Household';
import Scheduler from 'Components/AdvisorApp/Viewport/Scheduler';
import AccountSupport from 'Components/AdvisorApp/Viewport/AccountSupport';
import SnapshotContainer from 'Components/UI/Snapshot/SnapshotContainer';
import NewTimeline from './LandingPage/NewTimeline';
import HouseholdSummaryPage from './HouseholdSummaryPage';
import LandingPage from './LandingPage';
import Plan from './Plan';
import Questionnaire from './Questionnaire';
import BlueprintProvider from '../../../../Context/BlueprintContext';
import './index.css';
import FacetPlan from './FacetPlan';

const Household = () => {
  const { householdId, setHouseholdId } = useSimpleHousehold();

  return (
    <div
      className="Household"
      test={'advisor-app-household-root'}
    >
      <Router>
        <Switch>
          <Route
            exact
            path={advisorHouseholdPath}
            render={() => {
              const isBeta = QueryVal('isBeta') === 'true';
              // calling ''.split(',') results in [''], so we filter out empty strings
              const status = (QueryVal('status') || `${ACTIVE},${PROSPECT}`)
                .split(',')
                .filter(val => val !== '');
              const milestone = QueryVal('milestone') || '';
              const custodian = QueryVal('custodian') || '';
              const paymentMethod = QueryVal('paymentMethod') || '';
              let milestoneDate = (QueryVal('milestoneDate') || '')
                .split(',')
                .filter(val => val !== '')
                .filter(val => !Number.isNaN(val))
                .map(val => Number.parseInt(val, 10))
                .map(val => moment(val)); // [moment, moment] for start/end dates
              if (milestoneDate.length === 0) {
                milestoneDate = null;
              }
              let signedPADate = (QueryVal('signedPADate') || '')
                .split(',')
                .filter(val => val !== '')
                .filter(val => !Number.isNaN(val))
                .map(val => Number.parseInt(val, 10))
                .map(val => moment(val)); // [moment, moment] for start/end dates
              const escalated = QueryVal('escalated') === 'true';
              if (signedPADate.length === 0) {
                signedPADate = null;
              }

              let lastMeetingDate = (QueryVal('lastMeetingDate') || '')
                .split(',')
                .filter(val => val !== '')
                .filter(val => !Number.isNaN(val))
                .map(val => Number.parseInt(val, 10))
                .map(val => moment(val)); // [moment, moment] for start/end dates
              if (lastMeetingDate.length === 0) {
                lastMeetingDate = null;
              }

              return (
                <HouseholdSummaryPage
                  filterIsBeta={isBeta}
                  filterStatus={status}
                  filterMilestone={milestone}
                  filterCustodian={custodian}
                  filterPaymentMethod={paymentMethod}
                  filterMilestoneDate={milestoneDate}
                  filterLastMeeting={lastMeetingDate}
                  filterSignedPADate={signedPADate}
                  filterEscalated={escalated}
                  setHouseholdId={setHouseholdId}
                />
              );
            }}
          />
          <>
            <Route
              exact
              path={advisorHouseholdLandingPagePath}
              render={routerProps => (
                <LandingPage simpleHouseholdId={householdId} {...routerProps} />
              )}
            />
            <Route
              exact
              path={advisorHouseholdQuestionnaire}
              render={() => (
                <FDContentContainer maxWidth="xl">
                  <Questionnaire />
                </FDContentContainer>
              )}
            />
            <Route
              exact
              path={advisorHouseholdTimelinePath}
              render={() => <NewTimeline />}
            />
            <Route
              exact
              path={advisorSecureFilesPath}
              render={() => (
                <FDContentContainer maxWidth="xl">
                  <SecureFiles fileRowComponent={FileRow} />
                </FDContentContainer>
              )}
            />
            <Route path={advisorPlanPath} component={Plan} />
            <Route
              exact
              path={advisorHouseholdBlueprint}
              render={() => (
                <BlueprintProvider>
                  <Blueprint />
                </BlueprintProvider>
              )}
            />
            <Route exact path={advisorHouseholdSnapshot} component={SnapshotContainer} />
            <Route
              exact
              path={advisorAccountSupportPath}
              component={AccountSupport}
            />
            <Route
              exact
              path={advisorSchedulerPath}
              component={Scheduler}
            />
            <Route
              path={advisorFacetPlanPath}
              component={FacetPlan}
            />
          </>
        </Switch>
      </Router>
    </div>
  );
};

export default Household;
